import { getDetailedErrorMessage } from "../../../utils/validation";
/**
 * Pulls the most useful line out of a creative-service failure.
 *
 * Creative answers through two front doors — edge and its own Apigee proxy —
 * and Apigee reports its own rejections (quota, auth, routing) as
 * `{ fault: { faultstring } }` rather than the service's error body, which
 * `getDetailedErrorMessage` is the only one of the two that reads.
 */
const detailFrom = (apiError) => {
    const body = apiError?.response?.data;
    return body?.fault?.faultstring || body?.message || getDetailedErrorMessage(apiError, "");
};
/** Trace id off a failed response, which is when support most wants it. */
const requestIdFrom = (apiError) => apiError?.response?.headers?.["x-request-id"];
const withDetail = (baseMessage, apiError) => {
    const detail = detailFrom(apiError);
    return detail ? `${baseMessage} (${detail})` : baseMessage;
};
/** Error thrown when `GET /api/v1/creative/brand-kits/{id}` fails. */
export class BrandKitFetchFailed extends Error {
    constructor(apiError, baseMessage = "Failed to retrieve the brand kit. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BrandKitFetchFailed);
        }
        this.name = "BrandKitFetchFailed";
        this.message = withDetail(baseMessage, apiError);
    }
}
/**
 * Error thrown when `POST /api/v1/creative/brand/analyze` fails.
 *
 * A timeout gets its own message. A cold analysis scrapes and classifies a
 * whole site, so a caller that hit the client bound is far likelier to succeed
 * on a retry than one that got a 4xx — and a retry is cheap, since the service
 * caches on the normalized domain and the second run usually answers from
 * Postgres.
 */
export class BrandAnalysisFailed extends Error {
    constructor(apiError, baseMessage = "Failed to research this brand. Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BrandAnalysisFailed);
        }
        this.name = "BrandAnalysisFailed";
        this.requestId = requestIdFrom(apiError);
        this.message =
            apiError?.code === "ECONNABORTED"
                ? "Brand research timed out. The site may be slow to scrape — please try again."
                : withDetail(baseMessage, apiError);
    }
}
//# sourceMappingURL=errors.js.map